import React from "react";
import { useNavigate } from "react-router-dom";
import pasteListIcon from "../assets/pastelist.svg";
import compareIcon from "../assets/compare.svg";
import topDealsIcon from "../assets/topdeals.svg";
import myListIcon from "../assets/myList.svg";

const actions = [
  {
    id: "paste",
    label: "Paste List",
    iconSrc: pasteListIcon,
    path: "/",
    focusSearch: true,
  },
  {
    id: "compare",
    label: "Compare Prices",
    iconSrc: compareIcon,
    path: "/features",
  },
  {
    id: "deals",
    label: "Top Deals",
    iconSrc: topDealsIcon,
    path: "/top-deals",
  },
  {
    id: "lists",
    label: "My Lists",
    iconSrc: myListIcon,
    path: "/settings",
    search: "?tab=grocery",
  },
];

export default function HomeQuickActionsBar() {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-8">
        {actions.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => {
              navigate(`${item.path}${item.search || ""}`);
              if (item.focusSearch) {
                requestAnimationFrame(() => {
                  const el = document.querySelector('input[placeholder*="Paste"]');
                  el?.focus?.();
                });
              }
            }}
            className="flex min-h-[56px] w-full items-center gap-3 rounded-xl border border-[#E6EAF0] bg-white px-3 py-2.5 text-left shadow-sm sm:min-h-[60px] sm:px-4 sm:py-2.5"
          >
            <img
              src={item.iconSrc}
              alt=""
              width={48}
              height={48}
              className="h-10 w-10 shrink-0 pt-2 object-contain sm:h-12 sm:w-12"
              aria-hidden
            />
            <span className="text-[14px] font-bold leading-tight text-[#24303A] sm:text-[18px]">
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
